import React from 'react';
import Table from '../Table/Table';
import style from './NoticeableUSInvestors.module.css';
import useGurus from '../../hooks/useGurus';

const NoticeableUSInvestors = ({ stock, price = 0 }) => {
  const { gurus } = useGurus(stock.id);

  if (!gurus || gurus.length === 0) {
    return null;
  }

  return (
    <div className={style.container}>
      {gurus.map((guru) => (
        <a key={guru.id} href={`/portfolio/${guru.slug}/${stock.symbol.toLowerCase()}/transactions`} className={style.box}>
          <span className={style.name}>{guru.name}</span>
          <span className={style.value}>
            ${formatNumber(guru.total_shares * price)}
          </span>
        </a>
      ))}
    </div>
  );
};

export default NoticeableUSInvestors;

function formatNumber(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num;
}
